import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import {
    CenteredFlexColumn,
    FlexRow,
    LeftFlexRow,
    RightFlexRow,
} from "pro-features/styled components/StyledFlex/src/StyledFlex";

/* ── Gallery toolbar — shared by the social and AI ads galleries ──── */

export const TitleRow = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
`;

export const TitleRowInner = styled(RightFlexRow)`
    column-gap: 8px;
    align-items: center;
`;

export const TitleRowActions = styled(LeftFlexRow)`
    column-gap: 12px;
    align-items: center;
`;

export const Title = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[300])};
    margin-right: 8px;
`;

export const Footer = styled.footer<{ $showBorderTop?: boolean }>`
    display: flex;
    justify-content: right;
    padding: 12px 24px;
    ${({ $showBorderTop }) =>
        $showBorderTop &&
        css`
            border-top: 1px solid ${colorsPalettes.carbon[50]};
        `}
`;

export const EmptyStateWrapper = styled(CenteredFlexColumn)`
    min-height: 288px;
`;
